import Cookies from 'js-cookie';
import { Route, Redirect } from 'react-router-dom';

const NotLoggedInRoute = ({ component: Component, ...rest }) => (
  <Route
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
    render={(props) =>
      Cookies.get('customerToken') ? (
        <Redirect to="/profile" />
      ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Component {...props} />
      )
    }
  />
);

export default NotLoggedInRoute;
